import { Box, Divider, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import { CgWebsite } from "react-icons/cg";
import { TbApi } from "react-icons/tb";
import { GiTeacher } from "react-icons/gi";
import { FaDatabase } from "react-icons/fa";
import { CiMobile1 } from "react-icons/ci";
import { VscPreview } from "react-icons/vsc";
export const Service = () => {
  const ServicesComponent = ({ icon, title, description }) => {
    return (
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        w="full"
        bg="white"
        h="40"
      >
        <Flex px={{ base: "3", md: "10" }} alignItems={"flex-start"} gap="5">
          <Box p="2" bg="orange.100" borderRadius={"10"}>
            {icon}
          </Box>
          <Box>
            <Text textDecoration={"underline"} fontWeight={"medium"}>
              {title}
            </Text>
            <Text fontSize={"xs"}>{description}</Text>
          </Box>
        </Flex>
      </Flex>
    );
  };
  return (
    <Box id="service">
      <Box py="20" px={{ base: "10", md: "28" }}>
        <Flex flexDirection={"column"} textAlign={"left"}>
          <Box>
            <Text w={"fit-content"} fontSize={"5xl"} fontWeight={"medium"}>
              My Service
            </Text>
            <Divider border="2px solid #F0451A" width={"20"} />
          </Box>
          {/* <Text fontWeight={'bold'} fontSize={'5xl'} >What can I do for you</Text> */}
        </Flex>
        <SimpleGrid
          mt="10"
          justifyContent={"center"}
          gap="10"
          columns={{ base: "1", md: "3" }}
        >
          <ServicesComponent
            title={"Web Development Service"}
            description={
              "I build a custom web application development tailored to meet specific client requirements and business needs."
            }
            icon={<CgWebsite size="24" />}
          />
          <ServicesComponent
            title={"Database Services"}
            description={
              "Design and architecture using relational databases such as MySQL, alongside NoSQL database implementation using MongoDB and Firebase."
            }
            icon={<FaDatabase size={"24"} />}
          />

          <ServicesComponent
            title={"API Documentation"}
            description={
              "RESTful API development to facilitate communication between frontend and backend systems."
            }
            icon={<TbApi size="24" />}
          />
          <ServicesComponent
            title={"Mobile App Development"}
            description={
              "I Develop cross-platform mobile applications using React Native"
            }
            icon={<CiMobile1 size="24" />}
          />
          <ServicesComponent
            title={"Tutoring"}
            description={
              "Providing training sessions and workshops on web development technologies, best practices, and emerging trends"
            }
            icon={<GiTeacher size="24" />}
          />
          <ServicesComponent
            title={"UI/UX Design"}
            description={
              "Designing intuitive and visually appealing user interfaces (UI) for web applications, ensuring a seamless and engaging user experience (UX)."
            }
            icon={<VscPreview size="24" />}
          />
        </SimpleGrid>
      </Box>
    </Box>
  );
};
